import { observable, action, runInAction } from 'mobx';
import { isEmpty, cloneDeep, uniq } from 'lodash';

import { newRate, newValue } from '@tool/index';

const moCategory = observable({
  titleList: <any[]>[],
  list: <any[]>[],
  overview: <any[]>[],
  labels: <any[]>[],
  maxValue: 0,
});

const initCategory = action((res: any) => {
  // console.log('++++++ 职能类型涨薪率 ++++++ ', res);
  let years: any[] = [];
  let arr: any[] = [];
  let overview: any[] = [];
  let maxValue = 0;

  res.data?.map((item: any) => {
    item.year_data?.map((child: any) => {
      years.push(child.date);
    });
  });

  res.data?.map((item: any) => {
    let temp: any[] = [];
    item.year_data?.map((child: any) => {
      if (Math.abs(child.change_rate) > maxValue) maxValue = child.change_rate;
      temp.push(child.change_rate);
    });
    arr.push({
      type: item.function,
      arr: temp,
    });
  });

  res.overview?.map((item: any) => {
    let text = '';
    item?.map((child: any) => {
      text += child.value;
    });
    overview.push(text);
  });

  let newYears = uniq(years);
  newYears.unshift('');

  moCategory.titleList = newYears;
  moCategory.list = arr;
  moCategory.overview = overview;
  moCategory.maxValue = maxValue;
  moCategory.labels = res.total_function_data || [];
});

export default moCategory;
export { initCategory };
